function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q6man"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M429.1,145.8c0-16.7-3.7-61.7-5.8-82.2c-2.1-21.9-4.2-46.5-27.2-46.5c-23,0-25.6,25.7-27.5,47.9 c-1.8,20.3-5.5,66.7-5.5,80.8C363.1,165.9,429.1,165.9,429.1,145.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M381.7,159.5c0,0,6.5,9.2,15.4,8.1c15-1.9,15.4-8.5,15.4-8.5"
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 398.2,
  y1: 189.5,
  x2: 397.9,
  y2: 167.7
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M404.8,197.4l-22.9-0.3c0,0,9.6-8.9,18-7.5C408.3,191.1,404.8,197.4,404.8,197.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M368.4,66.3c8.4,0,13.9,5.7,15.8,1.4"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 379.1,
  cy: 55,
  r: 2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M349.3,8c2.5-6.8,30.5-8.8,60,2.1c29.5,10.9,49.4,30.7,46.9,37.5c-2.5,6.8-28.5,3.4-58-7.5 C368.7,29.2,346.8,14.8,349.3,8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M435.2,23.8c-5.6-0.2-16.3-2.9-28.2-7.3c-11.8-4.4-21.5-9.2-26-12.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M447,32.6c-9.5-0.6-25.1-4.5-42-10.8c-17-6.3-31.3-13.5-38.9-19.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M455.2,41.3c-12.9,0.1-32.3-4-53.1-11.7c-20.8-7.7-38.2-17.3-48-25.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M367.3,81.8c-0.7,0.2-1.1-0.6-0.6-1c4.3-3.2,12.8-8.3,26.8-12.9c19.4-6.3,35.7-7.6,39.8-7.8 c0.5,0,0.8,0.4,0.6,0.9l-8.2,17.6c-0.1,0.2-0.3,0.4-0.6,0.3C420.9,78.6,384.1,75.7,367.3,81.8z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st7",
  cx: 395.5,
  cy: 96.9,
  rx: 12.3,
  ry: 15.3
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M367.1,81.9c-1.4,17.6-3.1,40-3.7,54.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M373.9,80.2c-1.4,17.6-2.7,34.4-3.4,48.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M379.6,80.2c-1.4,17.6-2.7,34.4-3.4,48.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M363.5,135.8l-6.2,19c0,0,28.7,14.1,56.7,6c15.8-4.6,23-9.3,23-9.3l-8.6-15.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M385,137.4c0,0-4.6,6.1-25.6,11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M380.7,137.4c-3.8,2.1-10.1,4.8-20.2,7.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M428.8,135.8c-0.7-15.5-2.5-39-4.1-57"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M404.7,42.4c-0.5,4.3-1.7,10.3-4.6,14.7c-3.2,4.9-12.7,13-12.7,13"
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 375.9,
  y1: 145.2,
  x2: 375,
  y2: 149.5
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st8",
  points: "354.9,4.2 355.8,18.2 369.8,14.7 373.9,29.5 390.2,25.3 397.8,39.4 412.8,33.4 419.5,46.9 428,37.6  443.8,51.1 445.1,40.7 455.6,47.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M359.4,151c7,3,31.1,11.9,54.7,5.1c10-2.9,16.6-5.9,20.1-7.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M373,159.2L373,159.2c-2-0.4-3.2-2.4-2.8-4.3l0.6-2.9c0.4-2,2.4-3.2,4.3-2.8h0c2,0.4,3.2,2.4,2.8,4.3 l-0.6,2.9C376.9,158.3,374.9,159.6,373,159.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M370.9,151.5c0,0,1.9,1.6,3.1,1.9s3.9,0,3.9,0"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M370.2,154.8c0,0,1.9,1.6,3.1,1.9s3.9,0,3.9,0"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M421.8,135.1c0,0,2,5.1-11.7,9.2c-2.1,0.6-4.5,1.2-7.4,1.8c-21.7,4.2-34.6-11.3-34.6-11.3l-2.9,1.9 c0,0,14.2,18,38.3,13.1c3.2-0.6,5.9-1.3,8.2-2.1c15.2-4.7,12.9-10.7,12.9-10.7L421.8,135.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M430.1,134.3c-1.3,2.4-11.9,2.5-23.5,3.1c-11.6,0.6-47.9-0.7-47.9-0.7l1.9-8.8c0,0,34.1,1.2,45.4,0 c5.9-0.6,24.1-2.4,24.1-2.4V134.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M430.1,130.2c-25.6,5.7-64.9,2.2-64.9,2.2l1-4.4"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st8",
  cx: 395.5,
  cy: 96.9,
  rx: 15.6,
  ry: 19.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M419.5,78c0.2,17.7,2.2,34.2,2.9,48.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M413.8,78c0.2,17.7,2.2,34.2,2.9,48.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M407.9,109c0.5,6.4,1,12.6,1.3,18.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M401.7,114.8c0.3,4.3,0.6,8.5,0.8,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M395.2,116.7c0,4.4,0,8.5-0.1,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M389.6,115.5c0,4.4,0,8.5-0.1,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M384.3,110.7c-0.5,4-0.6,11.5,0,16.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M426.3,61.5c0,0-6.6,6.6-6.7,17.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M416.3,62.2c0,0-4.2,8-3.3,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M405.6,64.4c0,0-3,11-1.1,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M393.6,67.8c0,0-3.1,6.7-0.7,9.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M382.8,71.9c0,0-2,4.8,0.4,6.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M421.6,47.9c0.6,4.3,1.2,11.5,1.3,12.7"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q6slow"
}, /*#__PURE__*/React.createElement("g", {
  id: "Q6can4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M342.7,155.7h-5.1v8c0,0.4,0.2,0.8,0.5,1l3.9,3.2c0.5,0.4,0.8,1,0.8,1.6v21.7c0,1.3-1,2.3-2.3,2.3h-8.7h-8.7 c-1.3,0-2.3-1-2.3-2.3v-21.7c0-0.6,0.3-1.2,0.8-1.6l3.9-3.2c0.3-0.3,0.5-0.6,0.5-1v-8h-5.1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Q6can3"
}, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M307.9,155.7h-5.1v8c0,0.4,0.2,0.8,0.5,1l3.9,3.2c0.5,0.4,0.8,1,0.8,1.6v21.7c0,1.3-1,2.3-2.3,2.3h-8.7h-8.7 c-1.3,0-2.3-1-2.3-2.3v-21.7c0-0.6,0.3-1.2,0.8-1.6l3.9-3.2c0.3-0.3,0.5-0.6,0.5-1v-8h-5.1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Q6can2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M272.5,155.7h-5.1v8c0,0.4,0.2,0.8,0.5,1l3.9,3.2c0.5,0.4,0.8,1,0.8,1.6v21.7c0,1.3-1,2.3-2.3,2.3h-8.7h-8.7 c-1.3,0-2.3-1-2.3-2.3v-21.7c0-0.6,0.3-1.2,0.8-1.6l3.9-3.2c0.3-0.3,0.5-0.6,0.5-1v-8h-5.1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Q6can1"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Q6can1B",
  x: 336.6,
  y: 97.3,
  className: "st15",
  width: 16.4,
  height: 26.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Q6can1A",
  x: 341,
  y: 88,
  className: "st15",
  width: 7.4,
  height: 8.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M355,99.9l-3.9-3.2c-0.3-0.3-0.5-0.6-0.5-1v-8h-11.9v8c0,0.4-0.2,0.8-0.5,1l-3.9,3.2c-0.5,0.4-0.8,1-0.8,1.6v21.7 c0,1.3,1,2.3,2.3,2.3h8.7h8.7c1.3,0,2.3-1,2.3-2.3v-21.7C355.8,100.9,355.5,100.3,355,99.9z M341.7,89c0-0.6,0.4-1,1-1h4.1 c0.6,0,1,0.4,1,1v6c0,0.6-0.4,1-1,1h-4.1c-0.6,0-1-0.4-1-1V89z M352.6,121.8c0,0.6-0.4,1-1,1h-13.7c-0.6,0-1-0.4-1-1v-19 c0-0.3,0.1-0.6,0.4-0.8l5.5-4.2c0.2-0.1,0.4-0.2,0.6-0.2h3c0.2,0,0.5,0.1,0.6,0.2l5.2,4.2c0.2,0.2,0.4,0.5,0.4,0.8V121.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "Q6can1C",
  d: "M355.8,87.7h-5.1v8c0,0.4,0.2,0.8,0.5,1l3.9,3.2c0.5,0.4,0.8,1,0.8,1.6v21.7c0,1.3-1,2.3-2.3,2.3h-8.7H336 c-1.3,0-2.3-1-2.3-2.3v-21.7c0-0.6,0.3-1.2,0.8-1.6l3.9-3.2c0.3-0.3,0.5-0.6,0.5-1v-8h-5.1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Q6quick"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Q6hand"
}, /*#__PURE__*/React.createElement("g", {
  id: "Q6spear"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M428,135.3c-2.4-0.5-7.7-1.2-9.2-1.7c-1.2-0.4-3.9-1.6-5.5-2.3c-0.6-0.3-1.2,0.4-1.2,1.3v0.5h-24.9v-11.7l-4.5-3.8 c0,0-3.2,1.5-7.6,2.9v0l-6.2,1.6c-0.1,0-0.1,0-0.2,0l-3.8,0.6c-14.7,1.9-44.2,1.9-48.3,1.9l-3.7,7.5v7.3l3.7,7.5 c3.9,0,30.7,0,45.9,1.6l4.7,0.6c0.4,0.1,0.9,0.1,1.3,0.2l4.6,1.1c5.5,1.5,9.7,3.5,9.7,3.5l4.5-3.8v-11.7h24.9v0.5 c0,0.9,0.6,1.6,1.2,1.3c1.6-0.7,4.3-1.9,5.5-2.3c1.5-0.5,6.8-1.2,9.2-1.7C428.4,136.3,428.4,135.4,428,135.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "st17",
  points: "257.2,138.2 310.4,145.9 310.4,135.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M310.4,145.9v5.8c0,0,3.1-4.6,4.5-4.6c0.7,0,1.4,0,1.4,0"
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 147.1,
  x2: 315,
  y2: 124.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 318.4,
  y1: 147.2,
  x2: 318.4,
  y2: 124.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M316.4,147.1c4.3,0,36.3,0,50.2,2.2c8.2,1.3,16,4.9,16,4.9v-18.3"
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 375,
  y1: 151.2,
  x2: 375,
  y2: 120.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st19",
  x1: 361.3,
  y1: 123.4,
  x2: 361.3,
  y2: 148.6
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "257.2,135.9 257.2,132.3 255.5,131.3 242.9,135.9 255.5,140.5 257.2,139.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st17",
  points: "257.2,133.6 310.4,125.9 310.4,135.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M310.4,125.9v-5.8c0,0,3.1,4.6,4.5,4.6c0.7,0,1.4,0,1.4,0"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M316.4,124.7c4.3,0,36.3,0,50.2-2.2c8.2-1.3,16-4.9,16-4.9v18.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st17",
  points: "382.6,117.6 387.1,121.4 387.1,135.9 387.1,150.4 382.6,154.2  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 396.9,
  y: 123.4,
  transform: "matrix(6.123234e-17 -1 1 6.123234e-17 263.7039 535.5044)",
  className: "st17",
  width: 5.5,
  height: 24.9
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M428,136.4c0.4-0.1,0.4-1,0-1.1c-2.4-0.5-7.7-1.2-9.2-1.7c-1.2-0.4-3.9-1.6-5.5-2.3 c-0.6-0.3-1.2,0.4-1.2,1.3v6.4c0,0.9,0.6,1.6,1.2,1.3c1.6-0.7,4.3-1.9,5.5-2.3C420.2,137.7,425.6,136.9,428,136.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "375,120.5 375,151.2 367.8,149.4 361.3,148.6 361.3,123.4 368.7,122.2  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st19",
  points: "361.1,148.3 375,145 361.3,141.3 375,136 361.3,130.5 374.4,126.6 361.1,123.5  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315.4,
  y1: 136.1,
  x2: 310.2,
  y2: 136.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 134.3,
  x2: 310.4,
  y2: 133.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 131.9,
  x2: 310.4,
  y2: 130.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 130,
  x2: 310.4,
  y2: 128
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 127.8,
  x2: 310.4,
  y2: 124.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 138,
  x2: 310.4,
  y2: 138.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 140.4,
  x2: 310.4,
  y2: 141.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 142.3,
  x2: 310.4,
  y2: 144.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 315,
  y1: 144.5,
  x2: 310.4,
  y2: 147.6
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 135.9,
  x2: 382.6,
  y2: 135.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 133.6,
  x2: 382.6,
  y2: 133.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 131.2,
  x2: 382.6,
  y2: 130.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 128.9,
  x2: 382.6,
  y2: 127.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 126.5,
  x2: 382.6,
  y2: 124.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 124.2,
  x2: 382.6,
  y2: 121.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 138.2,
  x2: 382.6,
  y2: 138.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 140.6,
  x2: 382.6,
  y2: 141.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 142.9,
  x2: 382.6,
  y2: 144.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 145.3,
  x2: 382.6,
  y2: 147.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st18",
  x1: 387.1,
  y1: 147.6,
  x2: 382.6,
  y2: 149.9
}))))), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M406.5,144.1c-0.7,1.5-2.3,2.3-3.9,2c-1.9-0.4-3.1-2.2-2.7-4.1l5.7-27.1c0.3-1.4-0.1-2.8-1.1-3.9l-12.2-12.7 c-1.3-1.4-1.3-3.6,0.1-4.9c1.4-1.3,3.6-1.3,4.9,0.1l12.2,12.7c2.6,2.7,3.7,6.5,2.9,10.1l-5.7,27.1 C406.7,143.6,406.6,143.9,406.5,144.1z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Q6effect2"
}, /*#__PURE__*/React.createElement("line", {
  className: "st16E",
  x1: 239.7,
  y1: 103.3,
  x2: 253.9,
  y2: 87.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st16E",
  x1: 246.6,
  y1: 103.1,
  x2: 259.1,
  y2: 97.1
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Q6effect1"
}, /*#__PURE__*/React.createElement("line", {
  className: "st16E",
  x1: 236.7,
  y1: 112.9,
  x2: 245.9,
  y2: 130.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st16E",
  x1: 244.1,
  y1: 117.1,
  x2: 258.2,
  y2: 131.8
}));

var SvgQ6Svg = function SvgQ6Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q6svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ6Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q6svg.036e36c3.svg";
export { ForwardRef as ReactComponent };